import '@/styles/globals.scss'
import { useEffect } from 'react'
import { AppProps } from 'next/app'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { changeLanguage } from '../../i18n.js'

function MyApp({ Component, pageProps }: AppProps) {
  const title = 'دليلك للقبلة وأوقات الصلاة'
  const desc = 'مع "صلاتي"، صلاتك دائمًا في وقتها واتجاهها '
  const router = useRouter()
  const { asPath, pathname } = router
  const noIndex = pathname === '/feedback'

  useEffect(() => {
    if (!router.isReady) return
    // 优先使用路径中的语言
    const locale = router.locale
    // 若 URL 查询参数中含有 lang，则覆盖
    const queryLang = router.query.lang
    if (queryLang && typeof queryLang === 'string') {
      changeLanguage(queryLang)
    } else if (locale) {
      changeLanguage(locale)
    }
  }, [router.isReady, router.locale, router.query])

  return (
    <main>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="canonical" href="https://www.innerlightapp.com/" />
        <title>{title}</title>
        <meta name="description" content={desc} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        {noIndex && <meta name="robots" content="noindex" />}
        <link
          rel="alternate"
          href="https://www.innerlightapp.com/"
          hrefLang="x-default"
        />
      </Head>
      <Component {...pageProps} />
    </main>
  )
}

export default MyApp
